import styled from 'styled-components';

export const Container = styled.div``;

export const Title = styled.p`
  margin-top: 16px;
  font-size: 18px;
  font-weight: bold;
  color: #202020;
`;

export const CardBox = styled.div`
  display: flex;
  align-items: center;

  margin: 8px 0;
`;

export const CardTitle = styled.p`
  font-size: 18px;
  color: #202020;

  margin-left: 10px;
  margin-bottom: 0;
`;
